module.exports = __webpack_public_path__ + "img/UMSC-logo.24047e5b.svg";